export default class DtoVariousMatCounter {
    constructor(obj) {
        this.id = obj.id // Long,
        this.counterType = obj.counterType // Option[Int],
        this.brand = obj.brand // Option[String],
        this.readingCoefficient = obj.readingCoefficient // Option[Int],
        this.installationDate = obj.installationDate // Option[DateTime],
        this.revisionDate = obj.revisionDate // Option[DateTime]
        this.informative = obj.informative // Option[Boolean]
        this.provenImpossibility = obj.provenImpossibility // Option[Boolean],
        this.agencyDecisionDate = obj.agencyDecisionDate // Option[DateTime]
    }
}